import * as Sentry from '@sentry/react';
import { useQuery, useMutation } from '@tanstack/react-query';
import {
  fetchLogs,
  fetchScreen,
  sendDeviceCommand,
  getAllDevices,
} from 'api/admin/devices/devices';

const errorHandler = (error) => {
  console.log(error);
  Sentry.captureException(error);
};

const useFetchLogs = (mac) => {
  return useQuery({
    queryKey: ['getDeviceLogs', mac],
    queryFn: async () => {
      const { data } = await fetchLogs(mac);

      return {
        logs: data,
      };
    },
    onError: errorHandler,
    retry: 1,
    enabled: false,
    cacheTime: 1,
  });
};

const useFetchScreen = (mac) => {
  return useQuery({
    queryKey: ['getDeviceScreen', mac],
    queryFn: async () => {
      const { data } = await fetchScreen(mac);

      return {
        screen: data,
      };
    },
    onError: errorHandler,
    retry: 1,
    enabled: false,
    cacheTime: 1,
  });
};

const useSendDeviceCommand = (mac, action, options = {}) => {
  return useMutation({
    onError: errorHandler,
    ...options,
    mutationKey: ['appCommand', mac, action],
    mutationFn: async () => {
      const { data } = await sendDeviceCommand(mac, action);

      return {
        response: data,
      };
    },
    enabled: false,
    cacheTime: 1,
  });
};

const useFetchAllDevices = (pageNumber, searchTerm) => {
  return useQuery({
    queryKey: ['getAllDevices', pageNumber, searchTerm],
    queryFn: async () => {
      const { data } = await getAllDevices(pageNumber, searchTerm);

      return {
        devices: data.devices,
        total: data.total,
      };
    },
    onError: errorHandler,
    retry: 1,
  });
};
export { useFetchLogs, useFetchScreen, useSendDeviceCommand, useFetchAllDevices };
